/*
 * Scott & Jamie — wishlist (no app needed)
 * - Hearts ([data-sj-wish="<product-handle>"]) save/remove a product in this browser (localStorage).
 * - Header heart shows how many products are saved ([data-sj-wishlist-count]).
 * - Wishlist page ([data-sj-wishlist-grid]) renders the saved products via /products/<handle>?view=sj-wishlist-card.
 * Saved items stay on this device/browser; they are not linked to a customer account.
 */
(() => {
  if (window.sjWishlist) return;
  const KEY = 'sj-wishlist';

  const read = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter((h) => typeof h === 'string') : [];
    } catch {
      return [];
    }
  };
  let memory = read();
  const write = (list) => {
    memory = list;
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch {
      /* storage blocked: keep working for this page */
    }
  };
  const list = () => memory;

  function toast(message) {
    let el = document.querySelector('[data-sj-toast]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'sj-toast';
      el.setAttribute('data-sj-toast', '');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-on');
    clearTimeout(toast.timer);
    toast.timer = setTimeout(() => el.classList.remove('is-on'), 2400);
  }

  function sync() {
    const items = list();
    document.querySelectorAll('[data-sj-wish]').forEach((btn) => {
      const on = items.includes(btn.dataset.sjWish);
      if (btn.getAttribute('aria-pressed') !== String(on)) btn.setAttribute('aria-pressed', String(on));
      const name = btn.dataset.productTitle || 'this product';
      btn.setAttribute('aria-label', on ? `Remove ${name} from wishlist` : `Add ${name} to wishlist`);
    });
    document.querySelectorAll('[data-sj-wishlist-count]').forEach((el) => {
      el.textContent = items.length;
      el.hidden = items.length === 0;
    });
    document.querySelectorAll('[data-sj-wishlist-link]').forEach((el) => {
      el.setAttribute('aria-label', items.length ? `My wishlist (${items.length} saved)` : 'My wishlist');
    });
  }

  function toggle(handle) {
    const items = list().slice();
    const i = items.indexOf(handle);
    if (i === -1) {
      items.unshift(handle);
      write(items);
      toast('Saved to your wishlist');
    } else {
      items.splice(i, 1);
      write(items);
      toast('Removed from your wishlist');
    }
    sync();
    document.dispatchEvent(new CustomEvent('sj:wishlist:change', { detail: { items } }));
  }

  // Hearts can sit on a product card link: don't open the product when the heart is clicked.
  document.addEventListener(
    'click',
    (event) => {
      const btn = event.target.closest('[data-sj-wish]');
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      toggle(btn.dataset.sjWish);
    },
    true
  );

  // Changes made in another tab
  window.addEventListener('storage', (event) => {
    if (event.key !== KEY) return;
    memory = read();
    sync();
    renderPage();
  });

  // Cards added later (e.g. cart drawer, recommendations): keep their hearts in sync
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      sync();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // ---------- Wishlist page ----------
  async function renderPage() {
    const grid = document.querySelector('[data-sj-wishlist-grid]');
    if (!grid) return;
    const empty = document.querySelector('[data-sj-wishlist-empty]');
    const countEl = document.querySelector('[data-sj-wishlist-page-count]');
    const setCount = () => {
      const n = list().length;
      if (countEl) countEl.textContent = `${n} ${n === 1 ? 'item' : 'items'}`;
    };
    const items = list();
    setCount();
    if (!items.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.hidden = false;
    grid.setAttribute('aria-busy', 'true');
    const root = window.Shopify?.routes?.root || '/';
    const missing = [];
    const cards = await Promise.all(
      items.map(async (handle) => {
        try {
          const res = await fetch(`${root}products/${encodeURIComponent(handle)}?view=sj-wishlist-card`, { credentials: 'same-origin' });
          if (res.status === 404) {
            missing.push(handle);
            return '';
          }
          return res.ok ? await res.text() : '';
        } catch {
          return '';
        }
      })
    );
    // Products that no longer exist are taken off the list
    if (missing.length) write(list().filter((h) => !missing.includes(h)));
    grid.innerHTML = cards.join('');
    grid.removeAttribute('aria-busy');
    setCount();
    if (!list().length) {
      grid.hidden = true;
      if (empty) empty.hidden = false;
    }
    sync();
  }

  document.addEventListener('sj:wishlist:change', () => {
    if (document.querySelector('[data-sj-wishlist-grid]')) renderPage();
  });

  window.sjWishlist = { list, toggle };
  const start = () => {
    sync();
    renderPage();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
